import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

/**
 * 判断当前路由是否自行完成初始化。
 *
 * 问卷页面会在取得问卷详情后依据 loginType 执行登录校验，因此无需阻塞在站点初始化和全局 SSO 校验上。
 *
 * @param {Route} route 当前待进入的路由。
 * @returns {boolean} 是否跳过全局初始化。
 */
function shouldSkipGlobalInitialization (route: Route): boolean {
  return Boolean(route.meta?.skipGlobalInitialization)
}

async function beforeEach (this: any, to: any, from: any, next: any) {
  const app = this.app

  if (shouldSkipGlobalInitialization(to)) return next()

  // 等待sso校验完成再去请求接口
  try {
    await app.$checkSSO(to)
  } catch (err) {
    console.log('接口放行', err)
  }

  if (to.name === 'siteError') return next()
  app.$siteInitData().then(() => {
    next()
  }).catch(() => {
    next({ name: 'siteError' })
  })
}
function afterEach (this: any, to: any) {
  const app = this.app
  const breadcrumb = to.matched.slice(0).map((route: any) => {
    return {
      name: route.meta.title,
      to: route.name
        ? route.name
        : undefined
    }
  })
  app.$nextTick(() => {
    app.$bus.$emit('breadcrumb-change', breadcrumb)
  })
  document.title = to.meta.title ? `${to.meta.title}-${process.env.VUE_APP_MAINTITLE}` : `${process.env.VUE_APP_MAINTITLE}`
}
const router = new VueRouter({
  routes,
  base: '/',
  mode: 'history'
})
router.beforeEach(beforeEach.bind(router))
router.afterEach(afterEach.bind(router))

export default router
